import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  NavLink,
  Nav,
  Row,
  Col, NavItem,
} from "reactstrap";
import PageApiComponent from "airports/p11v5-nsru-backend/web-services/PageApiComponent";
import Lang from "lang/Lang";

function HomeNavbar(props) {
  const [renderLoopCount, setRenderLoopCount] = useState(0)
  const [collapseOpen, toggleCollapse] = React.useState(false)
  const [menuIntro, setMenuIntro] = useState([])

  React.useEffect(() => {
    document.addEventListener('scroll', event => {

    });

    var options = {
      offset: 400,
      tolerance: 5,
      onTop : function() {

      },
      onNotTop : function() {

      },
    };
    let headroom = new Headroom(document.getElementById("dark-navbar-main"), options);
    headroom.init();

    if(renderLoopCount < 1)
    {
      const pageApi = new PageApiComponent()
      pageApi.index(2, res => {
        setMenuIntro(res)
        setRenderLoopCount(renderLoopCount + 1)
      })
    }
  });



  let navbarType = "";
  switch (props.type) {
    case "dark":
      navbarType = "bg-default navbar-dark";
      break;
    case "transparent":
      navbarType = "navbar-transparent";
      break;
    case "primary":
      navbarType = "bg-primary navbar-dark";
      break;
    case "white":
      navbarType = "bg-white";
      break;
    default:
      navbarType = "bg-default navbar-dark";
      break;
  }



    /**
     * โหลดชุดข้อมูลการแปลภาษา
     */
    var pathnames = window.location.pathname.split("/");
    const lang = new Lang(pathnames[1]);

    //
    pathnames[1] = 'th';
    const switchCurrentToTh = pathnames.join("/");

    pathnames[1] = 'en';
    const switchCurrentToEn = pathnames.join("/");

    pathnames[1] = 'cn';
    const switchCurrentToCn = pathnames.join("/");

  return (
    <>
      <Navbar
        className={"navbar-main headroom " + navbarType}
        expand="lg"
        id="dark-navbar-main"
      >
          <Link to="/th/index">
            <img alt="" src={require("assets/img/brand/nsru-white.png")} id="brand-show-scroll" style={{
              height: "30px"
            }}></img>
          </Link>


          <button
            className="navbar-toggler"
            type="button"
            onClick={() => toggleCollapse(!collapseOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <Collapse
            id="navbar_global"
            navbar
            toggler="#navbar_global"
            isOpen={collapseOpen}
          >
            <div className="navbar-collapse-header">
              <Row>
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    onClick={() => toggleCollapse(!collapseOpen)}
                  >
                    <span></span>
                    <span></span>
                  </button>
                </Col>
              </Row>
            </div>
            <Nav
              className="navbar-nav-hover align-items-lg-center ml-lg-auto"
              navbar
            >
              {/* <UncontrolledDropdown nav>
                <DropdownToggle
                  tag={NavLink}
                  data-toggle="dropdown"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                >
                  <i className="fa fa-cube"></i>
                  <span className="nav-link-inner--text">TESSERACT</span>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                  <DropdownItem to="/playground" tag={Link}>
                    <i className="fa fa-cube text-muted"></i>
                    Backyard Playground
                  </DropdownItem>
                  <DropdownItem to="/credits" tag={Link}>
                    <i className="fa fa-cube text-muted"></i>
                    Credits
                  </DropdownItem>
                  <DropdownItem to="/clear" tag={Link}>
                    <i className="fa fa-cube text-muted"></i>
                    Destroy Cookie & Cache
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> */}

              <NavItem key="0">
                <NavLink
                  className="nav-link-icon"
                  href="/th/index"
                >
                  <i className="fa fa-home"></i>&nbsp;
                  <span className="nav-link-inner--text">{ lang.get('home', 'mainmenu') }</span>
                </NavLink>
              </NavItem>

              <UncontrolledDropdown nav key="1">
                <DropdownToggle
                  tag={NavLink}
                  data-toggle="dropdown"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                >
                  <i className="ni ni-app"></i>
                  <span className="nav-link-inner--text">{ lang.get('intro', 'mainmenu') }</span>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                    {menuIntro.map((page, i) =>
                        <DropdownItem key={i}
                            tag={Link}
                            to={"/th/" + page.slug}
                            className={"g-font-sarabun"}
                            toggle={false}
                        >
                            <i className="fa fa-cube"></i>
                            { page.title }
                        </DropdownItem>
                    )}
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav  key={2}>
                <DropdownToggle
                  tag={NavLink}
                  data-toggle="dropdown"
                  href="#faculty"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                >
                  <i className="ni ni-single-copy-04"></i>
                  <span className="nav-link-inner--text">{ lang.get('organization', 'mainmenu') }</span>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                  <DropdownItem key={0} tag={Link} to={"/goto/edu"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('edu', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={1} tag={Link} to={"/goto/ait"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('ait', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={2} tag={Link} to={"/goto/hss"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('hss', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={3} tag={Link} to={"/goto/ms"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('ms', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={4} tag={Link} to={"/goto/sci"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('sci', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={5} tag={Link} to={"/goto/president"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('op', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={6} tag={Link} to={"/goto/apr"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('apr', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={7} tag={Link} to={"/goto/aritc"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('aritc', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={8} tag={Link} to={"/goto/artculture"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('artculture', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={9} tag={Link} to={"/goto/rdi"} target="_blank"
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('rdi', 'organization') }
                  </DropdownItem>
                  <DropdownItem key={10} tag={Link} to={"/th/faculties"}
                    className={"g-font-sarabun"}
                  >
                    <i className="fa fa-cube "></i>
                    { lang.get('otherOrganization', 'mainmenu') }
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav  key={3}>
                <DropdownToggle
                  tag={NavLink}
                  data-toggle="dropdown"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                >
                  <i className="ni ni-single-copy-04"></i>
                  <span className="nav-link-inner--text">{ lang.get('education', 'mainmenu') }</span>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                  <DropdownItem key={0} to="/goto/courses" tag={Link}>
                    <i className="ni ni-align-center text-warning"></i>
                    การรับสมัคร
                  </DropdownItem>
                  <DropdownItem key={1} to="/goto/courses" tag={Link}>
                    <i className="ni ni-align-center text-warning"></i>
                    ข้อมูลหลักสูตร
                  </DropdownItem>
                  <DropdownItem key={2} to="/goto/verify" tag={Link}>
                    <i className="ni ni-align-center text-info"></i>
                    ระบบตรวจสอบคุณวุฒิรายบุคคล
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav key={4}>
                <DropdownToggle
                  tag={NavLink}
                  data-toggle="dropdown"
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                >
                  <i className="ni ni-tablet-button"></i>
                  <span className="nav-link-inner--text">{ lang.get('service', 'mainmenu') }</span>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                    <DropdownItem to={ lang.link('prospective') } tag={Link}>
                        <i className="fa fa-users"></i>
                        { lang.get('forProspective', 'mainmenu') }
                    </DropdownItem>
                    <DropdownItem to={ lang.link('student') } tag={Link}>
                        <i className="fa fa-users"></i>
                        { lang.get('forStudent', 'mainmenu') }
                    </DropdownItem>
                    <DropdownItem to={ lang.link('alumni') } tag={Link}>
                        <i className="fa fa-users"></i>
                        { lang.get('forAlumni', 'mainmenu') }
                    </DropdownItem>
                    <DropdownItem to={ lang.link('parent') } tag={Link}>
                        <i className="fa fa-users"></i>
                        { lang.get('forParent', 'mainmenu') }
                    </DropdownItem>
                    <DropdownItem to={ lang.link('person') } tag={Link}>
                        <i className="fa fa-users"></i>
                        { lang.get('forPerson', 'mainmenu') }
                    </DropdownItem>
                    <DropdownItem to={ lang.link('staff') } tag={Link}>
                        <i className="fa fa-users"></i>
                        { lang.get('forStaff', 'mainmenu') }
                    </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>&nbsp;&nbsp;&nbsp;

            <NavItem id="langItem">
              <a href={switchCurrentToTh}>
              	<img src={require('assets/img/flags/30x30/thailand.png')} />
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a href="http://developers.nsru.ac.th/histories/P11_NSRU/2017/en/home">
              	<img src={require('assets/img/flags/30x30/united_kingdom.png')} />
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;
            	<a href="http://developers.nsru.ac.th/histories/P11_NSRU/2017/cn/home">
              	<img src={require('assets/img/flags/30x30/china.png')} />
            	</a>
          	</NavItem>

        	</Nav>
      	</Collapse>
    	</Navbar>
  	</>
	);
}

HomeNavbar.defaultProps = {
	type: "dark",
};

HomeNavbar.propTypes = {
	type: PropTypes.oneOf(["dark", "transparent", "primary", "white"]),
};

export default HomeNavbar;
